(function () {
  var t = document.querySelector('.nav-toggle');
  if (t) t.addEventListener('click', function () {
    var open = document.body.classList.toggle('nav-open');
    t.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  var sort = document.querySelector('[data-sort]');
  if (sort) sort.addEventListener('change', function () {
    var u = new URL(window.location.href);
    u.searchParams.set('sort_by', sort.value);
    u.searchParams.delete('page');
    window.location.href = u.toString();
  });

  document.querySelectorAll('.thumb').forEach(function (b) {
    b.addEventListener('click', function () {
      var img = document.getElementById('pdp-main-img');
      if (img) { img.removeAttribute('srcset'); img.src = b.dataset.src; }
      document.querySelectorAll('.thumb').forEach(function (x) { x.classList.toggle('is-on', x === b); });
    });
  });

  var form = document.querySelector('[data-product-form]');
  var json = document.querySelector('[data-variants]');
  if (form && json) {
    var variants = JSON.parse(json.textContent);
    var money = function (cents) {
      try { return new Intl.NumberFormat(document.documentElement.lang || 'hy', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'AMD', maximumFractionDigits: 0 }).format(cents / 100); }
      catch (e) { return (cents / 100).toFixed(0); }
    };
    form.addEventListener('change', function () {
      var sel = [];
      form.querySelectorAll('[data-opt]:checked').forEach(function (r) { sel[+r.dataset.opt] = r.value; });
      form.querySelectorAll('[data-opt-label]').forEach(function (l) { l.textContent = sel[+l.dataset.optLabel] || ''; });
      var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); });
      var add = form.querySelector('[data-add]');
      if (!v) { add.disabled = true; return; }
      form.querySelector('[data-variant-id]').value = v.id;
      add.disabled = !v.available;
      var p = document.querySelector('[data-price]');
      if (p) p.textContent = money(v.price);
      var sku = document.querySelector('[data-sku]');
      if (sku) sku.textContent = v.sku || '';
      if (v.featured_image) { var img = document.getElementById('pdp-main-img'); if (img) { img.removeAttribute('srcset'); img.src = v.featured_image.src; } }
      var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u.toString());
    });
  }
  // Collection filters: apply automatically on change (no Apply button needed)
  var ff = document.querySelector('[data-filters]');
  if (ff) {
    var applyBtn = ff.querySelector('[data-filters-apply]');
    if (applyBtn) applyBtn.hidden = true;
    try {
      var y = sessionStorage.getItem('mb-filter-scroll');
      if (y !== null) { sessionStorage.removeItem('mb-filter-scroll'); window.scrollTo(0, +y); }
    } catch (e) {}
    var timer;
    var go = function () {
      clearTimeout(timer);
      var u = new URL(window.location.href);
      var names = {};
      Array.prototype.forEach.call(ff.elements, function (el) { if (el.name) names[el.name] = true; });
      Array.from(u.searchParams.keys()).forEach(function (k) { if (names[k] || k === 'page') u.searchParams.delete(k); });
      new FormData(ff).forEach(function (val, key) { if (String(val).trim() !== '') u.searchParams.append(key, val); });
      try { sessionStorage.setItem('mb-filter-scroll', String(window.scrollY)); } catch (e) {}
      ff.style.opacity = '.55'; ff.style.pointerEvents = 'none';
      window.location.href = u.toString();
    };
    ff.addEventListener('change', function (e) {
      if (e.target.type === 'number') { clearTimeout(timer); timer = setTimeout(go, 400); }
      else go();
    });
    ff.addEventListener('input', function (e) {
      if (e.target.type === 'number') { clearTimeout(timer); timer = setTimeout(go, 1200); }
    });
    ff.addEventListener('submit', function (e) { e.preventDefault(); go(); });
  }
})();
